// @ts-check
import React from 'react';
import { Box, Text } from '../../pdf-design-system';
import Columns from './Columns';

const ListDecoratorContext = React.createContext(undefined);

function useListDecorator() {
  const getNextDecorator = React.useContext(ListDecoratorContext);
  return getNextDecorator;
}

/**
 * @param {{children: React.ReactNode; format?: (index: number) => string | React.ReactElement }} props
 */
export function OrderedList({ children, format }) {
  const ref = React.useRef(0);
  return (
    <ListDecoratorContext.Provider
      value={() => {
        ref.current += 1;
        if (format) return format(ref.current);
        return ref.current;
      }}
    >
      {children}
    </ListDecoratorContext.Provider>
  );
}
/**
 * @param {{children: React.ReactNode; decorator?: string }} props
 */
export function UnorderedList({ children, decorator = '•' }) {
  return (
    <ListDecoratorContext.Provider value={() => decorator}>
      {children}
    </ListDecoratorContext.Provider>
  );
}

export function ListItem({ children, width = '10mm', ...rest }) {
  const getNextDecorator = useListDecorator();
  return (
    <Columns>
      <Text
        // @ts-ignore
        width={width}
        style={{ textAlign: 'right' }}
      >
        {getNextDecorator()}
      </Text>
      <Box
        // @ts-ignore
        width="100%"
      >
        {typeof children?.[0] === 'string' ? (
          <Text {...rest}>{children}</Text>
        ) : (
          <Box {...rest}>{children}</Box>
        )}
      </Box>
    </Columns>
  );
}
